let isLandingDemoStoreIsolated = false;
let isDetachedWorkspaceSurface = false;

/** Keep public demo state out of the signed-in workspace persistence channel. */
export function setLandingDemoStoreIsolation(isolated: boolean): void {
  isLandingDemoStoreIsolated = isolated;
}

export function isLandingDemoStoreIsolationActive(): boolean {
  return isLandingDemoStoreIsolated;
}

/**
 * A signed-in page that borrows the store for a few windows without being the
 * user's workspace, such as the hosted Connections page (`/connect`). It must
 * not write the persisted store or join cross-window workspace sync: its window
 * list would replace the dashboard's in another tab. Server-verified hints
 * (provider connected, checkout verified) still cross windows.
 */
export function setDetachedWorkspaceSurface(detached: boolean): void {
  isDetachedWorkspaceSurface = detached;
}

export function isDetachedWorkspaceSurfaceActive(): boolean {
  return isDetachedWorkspaceSurface;
}

export const isolatedBrowserStorage = {
  getItem: (name: string) => localStorage.getItem(name),
  setItem: (name: string, value: string) => {
    if (isDetachedWorkspaceSurface) return;
    if (!isLandingDemoStoreIsolated) localStorage.setItem(name, value);
  },
  removeItem: (name: string) => {
    if (isDetachedWorkspaceSurface) return;
    if (!isLandingDemoStoreIsolated) localStorage.removeItem(name);
  },
};
